import { AbstractControl, ValidatorFn } from '@angular/forms';
import IBAN from 'iban';

export function ibanValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    try {
      // empty value will not trigger error
      if (!control.value) return null;

      // trim input
      const iban = control.value.trim();
      // test beginning of IBAN for FI
      const pattern = /^FI/i;
      if (!pattern.test(iban)) return { countryCodeInvalid: true }

      const valid = IBAN.isValid(iban);
      return valid ? null : { invalid: true };
    } catch {
    }
    return { invalid: true };
  };
}
